import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';

import './flickfusion.scss';

export function Flickfusion({ photoInfo }) {
  const iframeSrc = get(photoInfo, 'extIntUrl');
  const parentTrackingId = get(photoInfo, 'parentTrackingId');

  return (
    <div className="flickfusion" data-tracking-parent={parentTrackingId}>
      <iframe
        className="border-0"
        title="Flickfusion"
        scrolling="no"
        src={iframeSrc}
        height="100%"
        width="100%"
        sandbox="allow-scripts allow-same-origin"
      />
    </div>
  );
}

Flickfusion.propTypes = {
  photoInfo: PropTypes.shape({}).isRequired,
};
